import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('SocialIconInsta')).forEach(el => {
    el.setAttribute('class', 'icon-wrapper');
    render(
      <svg
        className="connect__icon icon icon__instagram-circle"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 130 130"
      >
        <circle className="circle" cx="65" cy="65" r="63"/>
        <circle className="circle circle__inner" cx="65" cy="65" r="60"/>
        <path
          className="foreground"
          d="M65,30.16c11.35,0,12.69,0,17.17.25a23.4,23.4,0,0,1,7.9,1.46,14.11,14.11,0,0,1,8.06,8.06,23.4,23.4,0,0,1,1.46,7.9c.21,4.48.25,5.82.25,17.17s0,12.69-.25,17.17a23.4,23.4,0,0,1-1.46,7.9,14.11,14.11,0,0,1-8.06,8.06,23.4,23.4,0,0,1-7.9,1.46c-4.48.21-5.82.25-17.17.25s-12.69,0-17.17-.25a23.4,23.4,0,0,1-7.9-1.46,14.11,14.11,0,0,1-8.06-8.06,23.4,23.4,0,0,1-1.46-7.9c-.21-4.48-.25-5.82-.25-17.17s0-12.69.25-17.17a23.4,23.4,0,0,1,1.46-7.9,14.11,14.11,0,0,1,8.06-8.06,23.4,23.4,0,0,1,7.9-1.46c4.48-.21,5.82-.25,17.17-.25m0-7.66c-11.54,0-13,.05-17.52.26a31,31,0,0,0-10.32,2A21.7,21.7,0,0,0,24.73,37.16a31,31,0,0,0-2,10.32c-.21,4.53-.26,6-.26,17.52s.05,13,.26,17.52a31,31,0,0,0,2,10.32,21.7,21.7,0,0,0,12.43,12.43,31,31,0,0,0,10.32,2c4.53.21,6,.26,17.52.26s13,0,17.52-.26a31,31,0,0,0,10.32-2,21.7,21.7,0,0,0,12.43-12.43,31,31,0,0,0,2-10.32c.21-4.53.26-6,.26-17.52s0-13-.26-17.52a31,31,0,0,0-2-10.32A21.7,21.7,0,0,0,92.84,24.73a31,31,0,0,0-10.32-2c-4.53-.21-6-.26-17.52-.26Z"
          transform="translate(0 0)"
        />
        <path
          className="foreground"
          d="M65,43.18A21.82,21.82,0,1,0,86.82,65,21.82,21.82,0,0,0,65,43.18Zm0,36A14.17,14.17,0,1,1,79.17,65,14.18,14.18,0,0,1,65,79.17Z"
          transform="translate(0 0)"
        />
        <circle className="foreground" cx="65.19" cy="19.81" r="5.1" transform="translate(24 24)"/>
      </svg>,
      el
    );
  });
};
